import React from 'react';
import PropTypes from 'prop-types';

export default function LoadingOverlay({
  active,
  spinner,
  children,
}) {
  return (
    <div style={{ position: 'relative' }}>
      {active && (
        <div style={overlayStyle}>
          {spinner && <Spinner />}
        </div>
      )}
      {children}
    </div>
  );
}

function Spinner() {
  return (
    <div style={spinnerStyle} aria-label="Loading" />
  );
}

/* --- styles --- */

const overlayStyle = {
  position: 'absolute',
  inset: 0,
  background: 'rgba(255, 255, 255, 0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const spinnerStyle = {
  width: 32,
  height: 32,
  border: '4px solid #ccc',
  borderTopColor: '#333',
  borderRadius: '50%',
  animation: 'spin 0.8s linear infinite',
};

/* --- prop types --- */

LoadingOverlay.propTypes = {
  active: PropTypes.bool,
  spinner: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

LoadingOverlay.defaultProps = {
  active: false,
  spinner: true,
};
